module.exports = __webpack_public_path__ + "media/images/ac_banner2-711501ea735e61cd6d92ac5073f5187d.png";